<ng-template #modalPagoPlan let-d="dismiss" let-c="close">
	<div class="modal-xl">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div *ngIf="!currentEmisorObject" class="modal-wizard-title">Regularizar Plan</div>
				<div *ngIf="currentEmisorObject" class="modal-wizard-title">Regularizar Plan para la empresa {{currentEmisorObject.razonSocial}}</div>
				<div class="modal-wizard-desc">Seleccione según corresponda</div>
			</div>
		</div>
		<div class="modal-body">
			<div class="row mt-4">
				<div class="col-8">
					<app-planes-bloque *ngIf="planActual && planes" [planes]="planes" [type]="'blocked'" [planSeleccionado]="planSeleccionado" [planUsuario]="planActual" (actualizarPlan)="updatePlan($event)"></app-planes-bloque>
					<div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
						<div class="card-body">
							<p class="mr-2">Datos para emisión de la factura:</p>
							<div *ngIf="datosFacturacion">
								<div class="row">
									<div class="col-5">
										<ng-select class="comboEmpresa" [items]="rowsDatosFacturacion" [clearable]="false" placeholder="Seleccione Empresa" bindLabel="razonSocial" [(ngModel)]="datosFacturacion"> </ng-select>
									</div>
									<div class="col-7">
										<div class="ml-4" style="display: flex">
											<div>
												<p>RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
												<p>Comuna: {{ datosFacturacion.comuna }}</p>
												<p>Giro: {{ datosFacturacion.giro }}</p>
											</div>
											<div class="ml-4">
												<p>Razón Social: {{ datosFacturacion.razonSocial }}</p>

												<p>Dirección: {{ datosFacturacion.dirFact }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div *ngIf="planActual" class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark" data-plugin-sticky data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
						<div class="card-body" *ngIf="nuevaFechaCaducidad">
							<p>
								Tu plan actual terminó el {{ planActual.fechaCaducidad | date : "dd/MM/y" }}. Su nueva vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format("DD/MM/YYYY") }}</strong
								>. El tiempo se calcula desde el vencimiento de tu plan.
							</p>
							<p *ngIf="nuevaFechaCaducidad.isBefore(fechaActual)" style="color: red">Con este pago regularizas tu plan, pero aún mantendrías una mora de {{ nuevaFechaCaducidad.diff(fechaActual, "days") * -1 }} días.</p>
							<p *ngIf="resumenCuenta && resumenCuenta.proporcional > 0">El valor total del plan tiene un cobro adicional de {{ resumenCuenta.proporcional | currency : "$ " : "symbol" : "1.0-0" : "es" }} que corresponde al proporcional del plan desde el {{resumenCuenta.fechaInicioProporcional | date: "dd/MM/yyyy"}} hasta el {{ nuevaFechaCaducidad.format("DD/MM/YYYY")}}. Es decir, su plan por {{resumenCuenta.meses}} meses terminaría el {{resumenCuenta.fechaInicioProporcional | date: "dd/MM/yyyy"}} pero se agregó el cobro proporcional para cerrar el ciclo de facturación el día {{nuevaFechaCaducidad.format("DD/MM/YYYY")}}</p>
						</div>
					</div>
				</div>
				<div class="col-4">
					<app-resumen-bloque *ngIf="planActual && certificaciones" [planSeleccionado]="planSeleccionado" [planes]="planes" [certificaciones]="certificaciones" [type]="'extend'" [planUsuario]="planActual" (actualizarResumen)="notifyResumen($event)"></app-resumen-bloque>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div style="display: flex; align-items: center; flex-flow: row">
				<small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el pago.</small>
				<button *ngIf="emisoresSource.length > 1" type="button" class="btn ml-4 btn-info" (click)="openCambiarEmpresa(false)">Cambiar de empresa</button>
				<button type="button" class="btn ml-4 btn-primary" (click)="pagar()">Pagar plan seleccionado</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #modalCambiarEmpresa let-d="dismiss" let-c="close">
	<div class="modal-xl">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Cambiar de empresa</div>
				<div class="modal-wizard-desc">Seleccione según corresponda</div>
			</div>
		</div>
		<div class="modal-body">
			<ng-select [items]="emisoresSource" placeholder="Empresa" bindLabel="razonSocial" (change)="cambiarEmpresa(true)" [(ngModel)]="currentEmisorObject" [clearable]="false"> </ng-select>
		</div>
	</div>
</ng-template>
